import { c as _c } from "react/compiler-runtime";
import { RegionFilterButton, TreatmentFilterButton } from "@/features/search-result/ui/molecules";
import { FilterValue, Region } from "@/shared/types/type/search";
interface FilterProps {
  regionList: Region[];
  treatmentList?: FilterValue[];
  hideRegionAllOption?: boolean;
  hideTreatmentAllOption?: boolean;
  defaultRegionId?: number;
  defaultTreatmentId?: number;
}
const Filter = t0 => {
  const $ = _c(11);
  const {
    regionList,
    treatmentList,
    hideRegionAllOption,
    hideTreatmentAllOption,
    defaultRegionId,
    defaultTreatmentId
  } = t0;
  let t1;
  if ($[0] !== defaultRegionId || $[1] !== hideRegionAllOption || $[2] !== regionList) {
    t1 = <RegionFilterButton regionList={regionList} hideRegionAllOption={hideRegionAllOption} defaultRegionId={defaultRegionId} />;
    $[0] = defaultRegionId;
    $[1] = hideRegionAllOption;
    $[2] = regionList;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== defaultTreatmentId || $[5] !== hideTreatmentAllOption || $[6] !== treatmentList) {
    t2 = treatmentList && <TreatmentFilterButton treatmentList={treatmentList} hideTreatmentAllOption={hideTreatmentAllOption} defaultTreatmentId={defaultTreatmentId} />;
    $[4] = defaultTreatmentId;
    $[5] = hideTreatmentAllOption;
    $[6] = treatmentList;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t1 || $[9] !== t2) {
    t3 = <div className="flex items-center gap-2 px-4 pt-[6px] pb-3">{t1}{t2}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};
export default Filter;